import { render, staticRenderFns } from "./gtr-course-progress.vue?vue&type=template&id=3cf3fb57&"
import script from "./gtr-course-progress.ts?vue&type=script&lang=ts&"
export * from "./gtr-course-progress.ts?vue&type=script&lang=ts&"
import style0 from "./gtr-course-progress.vue?vue&type=style&index=0&id=3cf3fb57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports